import { useIntl } from 'react-intl';
import type { ResolvedNode } from '../../../../../vendor/agentplace-a2ui/walker.ts';
import { contentExplorationContext } from '../content-exploration.ts';
import { messages } from '../../localization/messages.ts';
import { AddToMessage } from './AddToMessage.tsx';

/** Comparison-specific wording over the general message-draft control. */
export function AddToComparison({
  node,
  id,
  label,
  selection,
}: {
  node: ResolvedNode;
  id: string;
  label: string;
  selection: Record<string, unknown>;
}) {
  const intl = useIntl();
  return (
    <AddToMessage
      item={{
        id: `${node.id}:${id}`,
        label,
        instruction: intl.formatMessage(messages.compareItem, { label }),
        context: contentExplorationContext(node, selection),
      }}
      label={intl.formatMessage(messages.addToCompare)}
    />
  );
}
